export default __webpack_public_path__ + "static/media/CircleOfInfluenceDebrief.d781c5d8.png";